export default __webpack_public_path__ + "static/media/1.17a60d27.svg";